/* eslint-disable @typescript-eslint/no-unused-vars */
import { Util } from '@microsec/utilities';
import { CommonChart } from '@microsec/models';

import { ChartData, ChartOptions, Plugin } from 'chart.js';
import { COMMON_CHART_CONFIG } from '@microsec/constants';

const titleFont = {
  size: 14,
};

const FREQUENCY_CHART_OPTIONS: ChartOptions = {
  maintainAspectRatio: false,
  aspectRatio: 1,
  animation: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  elements: {
    point: {
      radius: 1.5,
    },
  },
  scales: {
    x: {
      title: {
        display: false,
      },
      ticks: {
        color: COMMON_CHART_CONFIG.FONT_COLOR,
      },
      grid: {
        color: COMMON_CHART_CONFIG.GRID_COLOR,
      },
    },
    y: {
      beginAtZero: true,
      min: 0,
      max: undefined,
      title: {
        display: true,
        font: titleFont,
        text: 'Number of Threats Detected',
        color: COMMON_CHART_CONFIG.FONT_COLOR,
      },
      ticks: {
        color: COMMON_CHART_CONFIG.FONT_COLOR,
        stepSize: 1,
        callback: COMMON_CHART_CONFIG.INTEGER_LABEL_ONLY_CALLBACK,
      },
      afterBuildTicks: (axis) => {
        if (!!axis) {
          const max = axis.max;
          const steps = axis.max <= 5 ? 1 : Math.ceil(max / (max <= 50 ? 5 : 10) / 5) * 5;
          const ticks = [];
          for (let i = 0; i <= max; i += steps) {
            ticks.push({ value: i });
          }
          axis.ticks = ticks;
        }
        return;
      },
      grid: {
        color: COMMON_CHART_CONFIG.GRID_COLOR,
      },
    },
  },
};

const DEVICES_CHART_OPTIONS: ChartOptions = {
  maintainAspectRatio: false,
  aspectRatio: 1,
  animation: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        font: titleFont,
        text: 'Device',
        color: COMMON_CHART_CONFIG.FONT_COLOR,
      },
      grid: {
        color: COMMON_CHART_CONFIG.GRID_COLOR,
      },
      ticks: {
        color: COMMON_CHART_CONFIG.FONT_COLOR,
        font: {
          size: 10,
        },
      },
    },
    y: {
      title: {
        display: true,
        font: titleFont,
        text: 'Number of Threats Detected',
        color: COMMON_CHART_CONFIG.FONT_COLOR,
      },
      grid: {
        color: COMMON_CHART_CONFIG.GRID_COLOR,
      },
      ticks: {
        stepSize: 1,
        color: COMMON_CHART_CONFIG.FONT_COLOR,
      },
      beginAtZero: true,
    },
  },
};

export function getGradientBackgroundColor(ctx: any, color: string) {
  const gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
  const rgb = Util.hexToRgb(color);
  gradient.addColorStop(0, color);
  gradient.addColorStop(0.5, `rgba(${rgb?.r}, ${rgb?.g}, ${rgb?.b}, 0.4)`);
  gradient.addColorStop(1, `rgba(${rgb?.r}, ${rgb?.g}, ${rgb?.b}, 0)`);
  return gradient;
}

export const CHART_KEYS = {
  FREQUENCY: 'frequency',
  DEVICES: 'devices',
};

export const CHARTS: { [key: string]: CommonChart } = {
  [CHART_KEYS.FREQUENCY]: {
    type: 'line',
    key: CHART_KEYS.FREQUENCY,
    data: {} as ChartData,
    options: FREQUENCY_CHART_OPTIONS,
  },
  [CHART_KEYS.DEVICES]: {
    type: 'bar',
    key: CHART_KEYS.DEVICES,
    data: {} as ChartData,
    options: DEVICES_CHART_OPTIONS,
  },
};
